<template>
    <v-container fluid>
        <v-row style="padding-bottom: 20px;">
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="12"
                xl="10"
                lg="9"
                md="10"
                sm="10"
            >
                <h3>Multi Track Report - Projects in Multiple Statuses</h3>
            </v-col>
            <v-col 
                style="text-align: right; margin-top: 5px;"
                cols="12"
                xl="2"
                lg="3"
                md="2"
                sm="2"
            >
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            v-bind="attrs"
                            v-on="on"
                            @click="exportFile(URL_REPORT_MULTI_TRACK, {});"
                            style="margin-right: 10px;"
                        >
                            Export PDF
                        </v-btn>
                    </template>
                    <span>Export Report to PDF</span>
                </v-tooltip>
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            v-bind="attrs"
                            v-on="on"
                            @click="getRegisters"
                        >
                            Refresh
                        </v-btn>
                    </template>
                    <span>Refresh</span>
                </v-tooltip>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="listMultiTrack"
                    :options.sync="options"
                    :loading="loading"
                    :items-per-page="10"
                    no-data-text="No Record Found"
                >
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>
                                <v-tooltip left>
                                    <template v-slot:activator="{ on }">
                                        <a @click="goToServiceDetails(item.jobId)" v-on="on">
                                            {{ item.jobIdFormatted }}
                                        </a>
                                    </template>
                                    <span>Job Details</span>
                                </v-tooltip>
                            </td>
                            <td>{{ item.customerName }}</td>
                            <td>{{ item.projectName }}<br /><small>{{ item.customerAddress }}</small></td>
                            <td>{{ item.supervisorName }}</td>
                            <td>
                                <strong>{{ item.trackCount }}</strong>
                            </td>
                            <td>{{ item.trackDetails }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
    import Helpers from '@/utilities/Helpers';
    import { 
        URL_REPORT_MULTI_TRACK
    } from "@/utilities/Enums";

    export default ({

        mixins: [Helpers],

        data: () => ({
            
            loading: false,

            headers: [
                { text: "Job Id", value: "jobIdFormatted", sortable: true },
                { text: "Customer", value: "customerName", sortable: true },
                { text: "Project Name / Address", value: "projectName", sortable: true },
                { text: "Supervisor", value: "supervisorName", sortable: true },
                { text: "Active Tracks", value: "trackCount", sortable: true },
                { text: "Track Details", value: "trackDetails", sortable: true, width: "30%" }
            ],

            options: { rowsPerPage: 10, page: 1 },
            listMultiTrack: [],

            URL_REPORT_MULTI_TRACK
        }),

        methods: {

            async getRegisters() {
                this.showLoading();
                this.listMultiTrack = await this.$store.dispatch("reportModule/MultiTrackReport");
                this.hideLoading();
            },

            goToServiceDetails(id) {
                this.$router.push({ name: "serviceDetails", params: {id: id} });
            },
        },

        async created() {
            this.showLoading();
            await this.getRegisters();
            this.hideLoading();
        }
    })
</script>

<style>
    table > tbody > tr {
        cursor: pointer !important;
    }
</style>
